import { useEffect, useState } from "react";
import "./FadeSlideshow.css";
import clsx from "clsx";

export function FadeSlideshow({
  backgroundImage,
  images,
  imgAttrs,
}: {
  backgroundImage: string;
  images: string[];
  imgAttrs: React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >;
}) {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="fade-slideshow">
      <img
        src={backgroundImage}
        alt={imgAttrs.alt}
        {...imgAttrs}
        className={clsx("fade-slideshow__background-img")}
      />
      {images.map((src, i) => (
        <img
          key={i}
          src={src}
          alt={imgAttrs.alt}
          {...imgAttrs}
          className={clsx(
            "fade-slideshow__img",
            index === i && "fade-slideshow__img--active"
          )}
        />
      ))}
    </div>
  );
}
